import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { CreateBoardPopoverProps } from './CreateBoardPopover';

export const LazyCreateBoardPopoverWithAd: FunctionComponent<
  CreateBoardPopoverProps
> = (props) => {
  const CreateBoardPopoverWithAd = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "create-board-popover-with-ad" */ './CreateBoardPopoverWithAd'
      ),
    { namedImport: 'CreateBoardPopoverWithAd' },
  );

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <CreateBoardPopoverWithAd {...props} />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
